import { Chip } from "@mui/material";
import { Box } from "@mui/system";
import { FC, useEffect, useState } from "react";
import { ProjectService } from "../Services/project.service";
import { useLoading } from "../Shared/services/loading-context";
import { DefaultButton } from "./default-button.component";
import ModalComponent from "./modal.component";
import { useSnackbar } from "notistack";
import backButtonImg from "../assets/images/back.svg";
import { DropdownInput, IOption } from "./dropdown-input-component";

interface flatProps {
  isFlatModalOpen: boolean;
  getTowerData: (data?: any) => void;
  unSoled?: boolean;
}

export const FlatModal: FC<flatProps> = (props) => {
  const [isFlatSelectionModalOpen, setIsFlatSelectionModalOpen] =
    useState<any>(false);
  const [modalSelectionNumber, setModalSelectionNumber] = useState<number>(1);
  const [towerData, setTowerData] = useState<any[]>([]);
  const [floorData, setFloorData] = useState<any[]>([]);
  const [flatData, setFlatData] = useState<any[]>([]);
  const { loading, setLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const [blockNumbers, setBlockNumber] = useState<any[]>([]);
  const [propertyOptions, setPropertyOptions] = useState<IOption[]>([]);
  const [propertyType, setPropertyType] = useState<any>();
  const [unSoled, setUnSoled] = useState<boolean>(true);

  const style = {
    border: "none",
    width: "560px",
    height: "612px",
    maxHeight: "100vh",
    maxWidth: "100vw",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
  };

  const closeFlatSelectionModal = () => {
    setIsFlatSelectionModalOpen(false);
    setTowerData([]);
    setFloorData([]);
    setFlatData([]);
  };

  const getTowerData = async (propertyId:any) => {
    setIsFlatSelectionModalOpen(true);
    setLoading(true);
    const response = await ProjectService.getData(propertyId);
    setLoading(false);
    if (response.success) {
      setTowerData(response.data);
      setModalSelectionNumber(1);
    } else enqueueSnackbar(response.message, { variant: "error" });
  };

  const getFloorData = async (id: any) => {
    setModalSelectionNumber(2);
    setLoading(true);
    const response = await ProjectService.floorData(id);
    setLoading(false);
    if (response.success) {
      setFloorData(response.data);
    } else enqueueSnackbar(response.message, { variant: "error" });
  };

  const getFlatData = async (id: any) => {
    setModalSelectionNumber(3);
    setFlatData([]);
    setLoading(true);
    const response = await ProjectService.flatData(id, unSoled);
    setLoading(false);
    if (response.success) {
      setFlatData(response.data);
    } else enqueueSnackbar(response.message, { variant: "error" });
  };

  const getBlockNumber = (currElem: any) => {
    setIsFlatSelectionModalOpen(false);
    setModalSelectionNumber(1);
    setBlockNumber((prevState) => [...prevState, currElem]);
  };

  useEffect(() => {
    if (props.isFlatModalOpen) {
      getProperties();
      setUnSoled(props.unSoled ?? true);
    }
    else setIsFlatSelectionModalOpen(false);
  }, [props.isFlatModalOpen]);

  const getProperties = async () => {
    setLoading(true);
    const response = await ProjectService.getProperties();
    setLoading(false);
    if (response.success) {
      if (response.data?.length > 0) {
        const options: IOption[] = []
        response.data.forEach((item: { id: any; type: any; }) => {
          options.push({ key: item.id, value: item.id, text: item.type });
        });
        setPropertyOptions(options);
        console.log("response.data[0].id",response.data[0].id);
        setPropertyType(response.data[0].id);
        getTowerData(response.data[0].id);
      }
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  return (
    <ModalComponent
      // title="Select Customer"
      style={style}
      title="Flat Selection"
      isModalOpen={props.isFlatModalOpen}
      customHeader={false}
      hideModal={props.getTowerData}
    >
      {modalSelectionNumber == 1 ? (
        <>
          <div className="flat-selection" key="flat-selection-tower-header">
            <DefaultButton
              className="back-button"
              onClick={closeFlatSelectionModal}
            >
              <img src={backButtonImg} alt="Back Button" />
            </DefaultButton>
            <span className="addleads-flatselection-modal-text">
              Select Tower
            </span>
          </div>
          {/* {console.log("1" , propertyType , "2" , propertyOptions[0].value)
           */}
          
          <DropdownInput
            label="Proprty Type"
            name="proprty-type"
            value={propertyType ?? (propertyOptions.length > 0  ? propertyOptions[0].value : '')}
            options={propertyOptions}
            onChange={(e) => {
              getTowerData(e.target.value)
              setPropertyType(e.target.value)
            }}
          />
          <Box
            className="addleads-flatselection-modal-box"
            key="flat-selection-tower-box"
          >
            {towerData.map((currElem) => {
              return (
                <Chip
                  key={`tower-${currElem.tower}`}
                  className="addleads-modal-chip"
                  label={currElem.tower}
                  onClick={() => {
                    getFloorData(currElem.id);
                  }}
                />
              );
            })}
          </Box>
        </>
      ) : (
        <></>
      )}

      {modalSelectionNumber == 2 ? (
        <>
          <div className="flat-selection" key="flat-selection-floor-header">
            <DefaultButton
              onClick={() => setModalSelectionNumber(1)}
              className="back-button"
            >
              <img src={backButtonImg} alt="Back Button" />
            </DefaultButton>
            <span className="addleads-flatselection-modal-text">
              Select Floor
            </span>
          </div>
          <Box
            className="addleads-flatselection-modal-box"
            key="flat-selection-floor-box"
          >
            {floorData.map((currElem) => {
              return (
                <Chip
                  key={`floor-${currElem.floorNumber}`}
                  className="addleads-modal-chip"
                  label={currElem.floorNumber}
                  onClick={() => {
                    getFlatData(currElem.id);
                  }}
                />
              );
            })}
          </Box>
        </>
      ) : (
        <></>
      )}

      {modalSelectionNumber == 3 ? (
        <>
          <div
            className="flat-selection"
            key="flat-selection-block-number-header"
          >
            <DefaultButton
              onClick={() => setModalSelectionNumber(2)}
              className="back-button"
            >
              <img src={backButtonImg} alt="Back Button" />
            </DefaultButton>
            <span className="addleads-flatselection-modal-text">
              Select Block Number
            </span>
          </div>
          <Box
            className="addleads-flatselection-modal-box"
            key="flat-selection-block-number-box"
          >
            {flatData.map((currElem, index) => {
              return (
                <Chip
                  key={`block-${currElem.blockNumber}`}
                  className="addleads-modal-chip"
                  label={currElem.blockNumber}
                  onClick={() => {
                    props.getTowerData(currElem);
                  }}
                />
              );
            })}
          </Box>
        </>
      ) : (
        <></>
      )}
    </ModalComponent>
  );
};
